import { AxiosRequestConfig } from 'axios';
import { useEffect, useState } from 'react';

import { useDashboardContext } from './contexts';
import {
  GRAPH_GENERATE_STATUS,
  facilityActions,
  useFacilityContext,
} from './contexts/FacilityProvider';
import useGraphApiData from './useGraphApiData';

export const useGraphApiDataRevalidator = (
  url: string,
  config?: AxiosRequestConfig
) => {
  const { activeFacilitySnapShot } = useDashboardContext();
  const { state: facilityState, dispatch: facilityDispatch } =
    useFacilityContext();

  const [isRegenerated, setIsRegenerated] = useState(false);

  const [prevClientId, setPrevClientId] = useState(
    activeFacilitySnapShot.clientId
  );
  if (prevClientId !== activeFacilitySnapShot.clientId) {
    setPrevClientId(activeFacilitySnapShot.clientId);
    setIsRegenerated(true);
  }
  // const { sessionId } = useWebSocketContext();

  const { reValidate, ...rest } = useGraphApiData(url, {
    ...config,
    params: { ...config?.params, client_id: prevClientId },
  });

  useEffect(() => {
    if (
      activeFacilitySnapShot.userGraphGenerationStatus ===
        GRAPH_GENERATE_STATUS.APPLY_GENERATED_GRAPH ||
      activeFacilitySnapShot.userGraphGenerationStatus ===
        GRAPH_GENERATE_STATUS.DEFAULT_GENERATE_GRAPH
    ) {
      if (!isRegenerated) reValidate();

      setIsRegenerated(false);
      facilityDispatch(
        facilityActions.updateFacilityWiseGraphStatus(
          facilityState.selectedFacility,
          GRAPH_GENERATE_STATUS.IDLE_GENERATED_GRAPH
        )
      );
    }
  }, [
    activeFacilitySnapShot.userGraphGenerationStatus,
    activeFacilitySnapShot.clientId,
    facilityDispatch,
    reValidate,
    facilityState.selectedFacility,
    isRegenerated,
  ]);

  return { reValidate, ...rest };
};
export default useGraphApiDataRevalidator;
